import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20bustling%20modern%20open-air%20fashion%20market%20with%20rows%20of%20colorful%20clothing%20stalls%20and%20hanging%20garments%2C%20warm%20golden%20hour%20sunlight%20casting%20long%20shadows%20across%20concrete%20walkways%2C%20vibrant%20urban%20atmosphere%2C%20editorial%20travel%20photography%20style%2C%20rich%20saturated%20colors%20against%20neutral%20architecture%2C%20no%20text%20no%20logos%20no%20watermarks&width=1800&height=1200&seq=hero-unique-01&orientation=landscape)',
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-6 md:px-14 flex flex-col lg:flex-row items-center lg:items-start lg:justify-between">
        <div className="flex flex-col items-start max-w-2xl pt-20 lg:pt-0">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs font-medium tracking-wider uppercase mb-6">
            Updated Weekly &bull; 10,000+ Entries
          </span>

          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-[1.08] mb-6">
            Ultimate
            <br />
            Pandabuy
            <br />
            Spreadsheet
            <br />
            <span className="text-primary-400">Database 2026</span>
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-lg mb-8 leading-relaxed">
            Discover verified Pandabuy Spreadsheet lists, curated product finds,
            and optimized shopping data designed to help you find the best items
            at the lowest cost.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 flex items-center justify-center gap-2 group"
            >
              Explore Pandabuy Spreadsheet
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
            </a>
            <Link
              to="/pandabuy-spreadsheet-guide-2026"
              className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm whitespace-nowrap hover:bg-white/25 transition-all duration-300 flex items-center justify-center gap-2 border border-white/30"
            >
              View Latest Finds
              <i className="ri-arrow-right-down-line"></i>
            </Link>
          </div>
        </div>

        <div className="hidden lg:flex flex-col items-end justify-center gap-4 mt-20 lg:mt-0 lg:pt-32">
          <div className="flex flex-col items-end gap-3">
            <div className="flex items-center gap-3 text-white/70 text-sm">
              <span className="w-12 h-px bg-white/30"></span>
              <span>10,000+ Verified Entries</span>
            </div>
            <div className="flex items-center gap-3 text-white/70 text-sm">
              <span className="w-12 h-px bg-white/30"></span>
              <span>14 Categories Organized</span>
            </div>
            <div className="flex items-center gap-3 text-white/70 text-sm">
              <span className="w-12 h-px bg-white/30"></span>
              <span>Updated Every Week</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none select-none">
        <div className="font-heading text-[100px] md:text-[140px] lg:text-[180px] font-bold text-white/[0.07] leading-none whitespace-nowrap pl-6 md:pl-14">
          PANDABUY SPREADSHEET
        </div>
      </div>
    </section>
  );
}